import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';


export default function FileInput({ value, onChange, onBlur, ...props }) {
  return (
    <div>
      <input
        // Don't pass value to the input. Inputs of type="file" do not support setting
        // the value programmatically for security reasons.
        // For more details:
        // http://redux-form.com/5.2.5/#/examples/file?_k=m9n8jn
        {...props}
        type="file"
        onChange={(e) => {
          onChange(e);
          // Call onBlur when the field changes, because otherwise redux form does
          // not update field inputs after initial file selection until the user
          // clicks away from the field
          // Semi-known issue: https://github.com/erikras/redux-form/issues/329
          // We could create a codepen, but this workaround works great, and
          // redux-form is working on releasing v6.0.0, so we'll see if it's still broken
          // in that before digging in further
          onBlur(e);
        }}
        // Suppress onBlur, because otherwise when the user clicks on the field
        // and the file picker opens, onBlur is called, which causes the required validation to show
        // early.
        // This also fixes a bug where the original file disappears if the user edits an item with
        // a file field, clicks on the file field, and then cancels
        // Note: It is very important that we not suppress onFocus as well, because file inputs currently
        // do not successfully update in redux-form until they are focused again after the user has selected
        // a file. File inputs are auto-focused after the file selector closes, so this requires no abnormal
        // user behavior.
        onBlur={_.noop}
        tabIndex="-1"
      />
      <span
        style={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        }}
        className="form-control"
      >
        {value && value.length > 0 && value[0].name}
      </span>
    </div>
  );
}

FileInput.propTypes = {
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  onChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/components/forms/inputs/file.js